<template>
  <div class="flex items-center gap-2">
    <VanBadge
      :content="notification.getUnreadCountByMateId(mate.id)"
      :show-zero="false"
      max="99"
      @click="mateStore.toMateHome(mate)"
    >
      <UserAvatar :avatar-url="mate.mediaUrl" :mate="mate" class="w-16" />
    </VanBadge>
    <div class="flex flex-col">
      <template v-if="mate.status !== 0 || mate.type === MateType.SelfAvatar">
        <div class="text-sm font-semibold max-w-[8rem] text-ellipsis">
          {{ mate.name || $t("User.mate.unnamed") }}
        </div>

        <div class="flex items-center text-sm gap-1">
          <GenderBadge :gender="mate.gender" class="w-5 ml-[-4px]" />
          <div class="text-base-content/50 my-1">
            {{ useMateTypeTextByMate(mate) }}
          </div>
          <!-- <div v-if="mate.isNsfw" class="badge badge-sm badge-warning">
            NSFW
          </div> -->
        </div>
        <div class="flex gap-4" v-if="mate.type !== MateType.SelfAvatar">
          <div
            :class="[
              'flex flex-col items-center text-base-content/50',
              hasRouter && 'cursor-pointer',
            ]"
            @click="clickCount('#following')"
          >
            <div class="text-base">
              {{ emojiCount }}
            </div>
            <div class="text-xs">{{ $t("Social.likes") }}</div>
          </div>
          <!-- <div
            :class="[
              'flex flex-col items-center text-base-content/50',
              hasRouter && 'cursor-pointer',
            ]"
            @click="clickCount('#admirer')"
          >
            <div class="text-base">
              {{ mate.admirerCount }}
            </div>
            <div class="text-xs">{{ $t("Social.admirer") }}</div>
          </div> -->
          <!-- <div
            :class="[
              'flex flex-col items-center text-base-content/50',
              hasRouter && 'cursor-pointer',
            ]"
            @click="clickCount('#follower')"
          >
            <div class="text-base">
              {{ mate.followerCount }}
            </div>
            <div class="text-xs">{{ $t("Social.followers") }}</div>
          </div> -->
        </div>
      </template>
      <div v-else>
        <span v-if="mate.status === 0">
          {{ $t("User.mate.unnamed") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useNotification } from "@/stores/notification";
import { Mate } from "@/types/entity";
import { useMateTypeTextByMate } from "@/use/common";
import { computed, PropType } from "vue";
import { useRouter } from "vue-router";
import { useMate } from "@/stores/mate";
import { MateType } from "@/enums/mateEnums";

const props = defineProps({
  mate: {
    type: Object as PropType<Mate>,
    required: true,
  },
  hasRouter: {
    type: Boolean,
    default: false,
  },
  showUnread: {
    type: Boolean,
    default: false,
  },
});

const notification = useNotification();
const router = useRouter();
const mateStore = useMate();

const clickCount = (hash: string) => {
  if (!props.hasRouter) return;
  router.push({ name: "socialList", hash });
};

const emojiCount = computed(() => {
  if (props.mate.isUser) {
    return mateStore.userMateEmojiCount;
  }
  return props.mate.emojiCount || 0;
});
</script>
